import {API, Designer, DesignerAPI, Endpoints, PageModel} from '@brg/api';
import { useEffect, useState } from 'react';
import { ComputedDesigner, computeDesigner } from 'shared/helpers/computeData';

export interface Expert extends Designer {
    tagProjectsCount: number;
}

export const useGetTagExperts = (id: string, date: number, lang: string, callback?: (n: number) => void, disable?: boolean) => {
    const [data, setData] = useState<PageModel<ComputedDesigner>>();

    const fetch = (id: string) => {
        DesignerAPI.GetList({ tagIds_Expert: [id] })
            .then((r: Response) => r.json())
            .then((r) => ({...r, data: API.toLang(r.data, lang)}))
            .then((r) => {
                setData({
                    ...r,
                    data: r?.data?.map((designer:Designer<'Local'>) => computeDesigner(designer))
                })
                callback && callback(r.data?.length)
            })
    }

    useEffect(() => {
        if (!disable) {
            fetch(id)
        }
    } , [id, date, lang, disable])

    return data;
}

export const useGetTagEditors = (id: string, date: number, lang: string, callback?: (n: number) => void, disable?: boolean) => {

    const [data, setData] = useState<any>();

    const fetch = (id: string) => {
        API.fetch(Endpoints.geograffee + '/api/Designer/GetDesignersWithPolicy?policy=tag_editor_' + id, {})
            .then((r: Response) => r.json())
            .then((r) => ({data: API.toLang(r, lang)}))
            //@ts-ignore
            .then((r: any) => {
                setData({
                    data: r?.data?.map((designer:Designer<'Local'>) => computeDesigner(designer))
                })
                callback && callback(r.data?.length)
            })
    }

    useEffect(() => {
        if (!disable) {
            fetch(id)
        }
    } , [id, date, lang, disable])

    return data;
}import {API, Designer, DesignerAPI, Endpoints, PageModel} from '@brg/api';
import { useEffect, useState } from 'react';
import { ComputedDesigner, computeDesigner } from 'shared/helpers/computeData';

export interface Expert extends Designer {
    tagProjectsCount: number;
}

export const useGetTagExperts = (id: string, date: number, lang: string, callback?: (n: number) => void, disable?: boolean) => {
    const [data, setData] = useState<PageModel<ComputedDesigner>>();

    const fetch = (id: string) => {
        DesignerAPI.GetList({ tagIds_Expert: [id] })
            .then((r: Response) => r.json())
            .then((r) => ({...r, data: API.toLang(r.data, lang)}))
            .then((r) => {
                setData({
                    ...r,
                    data: r?.data?.map((designer:Designer<'Local'>) => computeDesigner(designer))
                })
                callback && callback(r.data?.length)
            })
    }

    useEffect(() => {
        if (!disable) {
            fetch(id)
        }
    } , [id, date, lang, disable])

    return data;
}

export const useGetTagEditors = (id: string, date: number, lang: string, callback?: (n: number) => void, disable?: boolean) => {

    const [data, setData] = useState<any>();

    const fetch = (id: string) => {
        API.fetch(Endpoints.geograffee + '/api/Designer/GetDesignersWithPolicy?policy=tag_editor_' + id, {})
            .then((r: Response) => r.json())
            .then((r) => ({data: API.toLang(r, lang)}))
            //@ts-ignore
            .then((r: any) => {
                setData({
                    data: r?.data?.map((designer:Designer<'Local'>) => computeDesigner(designer))
                })
                callback && callback(r.data?.length)
            })
    }

    useEffect(() => {
        if (!disable) {
            fetch(id)
        }
    } , [id, date, lang, disable])

    return data;
}